
// src/actions/report.js

import api from './gamba-api'
import { emitAlertMessage, clearAlertMessage } from './alert-message'

export const POST_USER_REPORT = "POST_USER_REPORT"
export const POST_USER_REPORT_REQUESTED = "POST_USER_REPORT_REQUESTED"
export const POST_USER_REPORT_COMPLETED = "POST_USER_REPORT_COMPLETED"
export const POST_USER_REPORT_FAILED = "POST_USER_REPORT_FAILED"

export function postUserReportRequested(user_id, target_user_id) {
  return {
    type: POST_USER_REPORT_REQUESTED,
    user_id, target_user_id
  }
}

export function postUserReport(user_id, target_user_id) {
  return function(dispatch) {
    dispatch(postUserReportRequested(user_id, target_user_id))
    return api.post(`/user/user_report`, { user_id, target_user_id })
        .then((results)=> {
          dispatch(postUserReportCompleted(user_id, target_user_id, results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(postUserReportFailed(user_id, target_user_id, error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function postUserReportCompleted(user_id, target_user_id, results) {
  return {
    type: POST_USER_REPORT_COMPLETED,
    user_id, target_user_id, results,
  }
}

export function postUserReportFailed(user_id, target_user_id, error) {
  return {
    type: POST_USER_REPORT_FAILED,
    user_id, target_user_id, error,
  }
}

export const POST_CONTENT_REPORT = "POST_CONTENT_REPORT"
export const POST_CONTENT_REPORT_REQUESTED = "POST_CONTENT_REPORT_REQUESTED"
export const POST_CONTENT_REPORT_COMPLETED = "POST_CONTENT_REPORT_COMPLETED"
export const POST_CONTENT_REPORT_FAILED = "POST_CONTENT_REPORT_FAILED"

export function postContentReportRequested(user_id, diary_id, comment_id) {
  return {
    type: POST_CONTENT_REPORT_REQUESTED,
    user_id, diary_id, comment_id
  }
}

export function postContentReport(user_id, diary_id, comment_id) {
  return function(dispatch) {
    dispatch(postContentReportRequested(user_id, diary_id, comment_id))
    return api.post(`/user/content_report`, { user_id, diary_id, comment_id })
        .then((results)=> {
          dispatch(postContentReportCompleted(user_id, diary_id, comment_id, results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(postContentReportFailed(user_id, diary_id, comment_id, error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function postContentReportCompleted(user_id, diary_id, comment_id, results) {
  return {
    type: POST_CONTENT_REPORT_COMPLETED,
    user_id, diary_id, comment_id, results,
  }
}

export function postContentReportFailed(user_id, diary_id, comment_id, error) {
  return {
    type: POST_CONTENT_REPORT_FAILED,
    user_id, diary_id, comment_id, error,
  }
}


// WEBPACK FOOTER //
// ./src/actions/report.js